import React, { useState } from 'react';

// components
import TabSwitcherSmall from '_components/atoms/tab-switcher-small';
import CreateAdhocTask from './create-adhoc-task';

// styles
import { Spacing } from '_styles';
import { BookingForm } from '_components/molecules';

const AddTaskView = ({ onClose }) => {
    // Tab state
    const [activeTab, setActiveTab] = useState('add-booking');

    // Tab configuration
    const tabs = [
        { value: 'add-booking', label: 'Add Booking' },
        { value: 'create-adhoc', label: 'Create Adhoc' },
    ];

    // Handle tab change
    const handleTabChange = (tabValue) => {
        setActiveTab(tabValue);
    };

    return (
        <div>
            <TabSwitcherSmall
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                containerStyle={{}}
                tabsListStyle={{
                    marginBottom: Spacing.SCALE_16,
                }}
                tabContentStyle={{}}
            >
                {/* Add Booking Tab */}
                {activeTab === 'add-booking' && (
                    <BookingForm />
                )}

                {/* Create Adhoc Tab */}
                {activeTab === 'create-adhoc' && (
                    <CreateAdhocTask onClose={onClose} />
                )}

            </TabSwitcherSmall>
        </div>
    );
};

export default AddTaskView;
